import React from "react";
import { FaFileAlt, FaCheckCircle } from "react-icons/fa";
const StudentDocuments = () => {
  const documents = [
    "Birth Certificate (Proof of Age)",
    "Filled Admission Form with Photograph",
    "Two Passport Size Photographs",
    "Previous School Report Card / Progress Report",
    "Transfer Certificate (if applicable)",
    "Aadhar Card (Student/Parent, if required)",
  ];
  return (
    <section className="relative py-16 px-4 md:px-10 bg-gradient-to-br from-orange-50 via-white to-red-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold text-red-600 bg-red-100 rounded-full mb-3">
            Documents
          </span>
          <h2 className="text-2xl md:text-4xl font-extrabold text-gray-900">
            Student{" "}
            <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">
              Documents Required
            </span>
          </h2>
          <p className="text-gray-600 mt-3 text-sm md:text-base">
            Please ensure the following documents are submitted at the time of admission.
          </p>
        </div>
        <div className="bg-white rounded-2xl shadow-lg border border-orange-100 p-6 md:p-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {documents.map((doc, index) => (
              <div
                key={index}
                className="flex items-start gap-3 bg-orange-50 rounded-xl p-4"
              >
                <FaCheckCircle className="text-green-500 mt-1" />
                <p className="text-sm text-gray-700 font-medium">{doc}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-6 text-center">
          <p className="text-xs md:text-sm text-gray-500">
            Note: All documents should be original along with photocopies for verification.
          </p>
        </div>
      </div>
    </section>
  );
};
export default StudentDocuments;